import { X } from "lucide-react";
import React, { useCallback, lazy, Suspense } from "react";
import { winLossPoint } from "src/helpers";
import ChartSkeleton from "src/components/skeleton/ChartSkeleton";

const LazyWinlossChart = lazy(() => import("src/common/charts/winlossChart"));

interface WinLossProps {
  isOpen: boolean;
  winLossLoader: boolean;
  onClose: () => void;
  darkMode: boolean | undefined;
  stock: winLossPoint[];
  selectedSymbol: string | undefined;
}

const WinLossChartModal = React.memo(function WinLossChartModal({
  isOpen,
  onClose,
  darkMode,
  stock,
  selectedSymbol,
  winLossLoader,
}: WinLossProps) {
  const handleContentClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  if (!isOpen) return null;

  const isDark = !!darkMode;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-[#1E1E2D] rounded-xl shadow-2xl w-full max-w-5xl max-h-[90vh] flex flex-col"
        onClick={handleContentClick}
      >
        <div className="px-1 py-1 flex justify-between items-center">
          <h2 className="text-lg dark:text-white font-semibold mb-1 ml-3">
            {selectedSymbol}: Win-Loss Ratio (Shows the historical ratio of the
            stock closing in positive for specific month)
          </h2>
          <button
            onClick={onClose}
            className="cursor-pointer text-gray-400 hover:text-gray-600 dark:hover:text-white p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        <div className="p-1 overflow-y-auto flex-1">
          <div className="rounded-lg h-96">
            {winLossLoader ? (
              <ChartSkeleton />
            ) : stock?.length === 0 ? (
              <div className="text-gray-500 text-center py-25">
                No data found
              </div>
            ) : (
              <Suspense fallback={<ChartSkeleton />}>
                <LazyWinlossChart
                  winLossChart={stock}
                  darkMode={isDark}
                  isExpand={true}
                />
              </Suspense>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default WinLossChartModal;
